import { React, useState, useEffect, useContext } from 'react'
import "../../../assets/css/table.css";
import Loading from "react-fullscreen-loading";
import DivLoader from "../../../component/utilities/Spinner";
import DataTable from "react-data-table-component";
import axios from "axios";
import { toast } from "react-toastify";
import * as CONST from "../../../component/config/Constant"
import { AuthContext } from '../../../component/context/AuthContext';
import { Modal, Button } from 'react-bootstrap';
import ReactSwitch from 'react-switch';
import * as SwitchProps from '../../../component/utilities/ReactSwitchReactSwitchProps';
import Swal from 'sweetalert2'

function RequestCategories() {
    const [authUserData] = useContext(AuthContext);
    const [fullLoading, setFullLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [show, setShow] = useState(false);
    const [action, setAction] = useState('Add');
    const [disabled, setDisabled] = useState('');

    // Form
    const [categoryId, setCategoryId] = useState('');
    const [name, setName] = useState('');
    const [code, setCode] = useState('');
    const [description, setDescription] = useState('');
    const [requiresApproval, setRequiresApproval] = useState(false);
    const [requiresAsset, setRequiresAsset] = useState(false);
    const [sortOrder, setSortOrder] = useState(0);

    // Search
    const [searchName, setSearchName] = useState('');
    const [searchStatus, setSearchStatus] = useState('');

    // Pagination
    const [totalRows, setTotalRows] = useState(0);
    const [totalRecords, settotalRecords] = useState(0);
    const [perPage, setPerPage] = useState(20);
    const [activePage, setActivePage] = useState(1);
    const [maxPageLimit, setMaxPageLimit] = useState(20);
    const [minPageLimit, setMinPageLimit] = useState(0);
    const [dataSort, setDataSort] = useState({ order: 'asc', order_by: 'sort_order' });
    const [searchParam, setSearchParam] = useState({});

    let isToken = '';
    if (authUserData && authUserData[0]) {
        isToken = authUserData[0].token || '';
    }

    useEffect(() => {
        if (isToken) fetchData();
    }, [searchParam, dataSort, activePage, perPage, isToken]);

    async function fetchData() {
        setLoading(true);
        try {
            const response = await axios.post(CONST.REQUEST_CATEGORY_LIST, {
                limit: perPage,
                page_number: activePage,
                search_input: searchParam,
                sort: dataSort,
            }, { headers: { 'Authorization': `Bearer ${isToken}` } });

            if (response.data.status === 'success') {
                setData(response.data.data || []);
                setTotalRows(response.data.count || 0);
                settotalRecords(response.data.count || 0);
            } else {
                setData([]);
                setTotalRows(0);
                settotalRecords(0);
            }
        } catch (error) {
            toast.error("Error fetching categories");
        }
        setLoading(false);
    }

    const handleShow = async (action, id) => {
        setAction(action);
        if (action === 'Edit' && id) {
            try {
                const res = await axios.get(CONST.GET_REQUEST_CATEGORY_BY_ID + id, {
                    headers: { 'Authorization': `Bearer ${isToken}` }
                });
                if (res.data.status === 'success') {
                    const d = res.data.data;
                    setCategoryId(d.id);
                    setName(d.name);
                    setCode(d.code);
                    setDescription(d.description || '');
                    setRequiresApproval(d.requires_approval == 1);
                    setRequiresAsset(d.requires_asset == 1);
                    setSortOrder(d.sort_order || 0);
                }
            } catch (error) {
                toast.error("Error fetching category");
            }
        }
        setShow(true);
    };

    const handleClose = () => {
        setShow(false);
        setCategoryId('');
        setName('');
        setCode('');
        setDescription('');
        setRequiresApproval(false);
        setRequiresAsset(false);
        setSortOrder(0);
    };

    // Auto-generate code from name
    const handleNameChange = (val) => {
        setName(val);
        if (action === 'Add') {
            setCode(val.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, ''));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!name || !code) {
            toast.error("Name and Code are required.");
            return;
        }
        setDisabled('disabled');
        try {
            const payload = {
                name, code, description,
                requires_approval: requiresApproval ? 1 : 0,
                requires_asset: requiresAsset ? 1 : 0,
                sort_order: sortOrder,
            };
            let response;
            if (action === 'Add') {
                response = await axios.post(CONST.ADD_REQUEST_CATEGORY, payload, {
                    headers: { 'Authorization': `Bearer ${isToken}` }
                });
            } else {
                payload.id = categoryId;
                response = await axios.put(CONST.EDIT_REQUEST_CATEGORY, payload, {
                    headers: { 'Authorization': `Bearer ${isToken}` }
                });
            }
            if (response.data.status === 'success') {
                toast.success(response.data.message);
                handleClose();
                fetchData();
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error("Something went wrong.");
        }
        setDisabled('');
    };

    const deleteHandler = (id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "This category will be deleted.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const res = await axios.delete(CONST.DELETE_REQUEST_CATEGORY, {
                        data: { id: id },
                        headers: { 'Authorization': `Bearer ${isToken}` }
                    });
                    if (res.data.status === 'success') {
                        toast.success(res.data.message);
                        fetchData();
                    } else {
                        toast.error(res.data.message);
                    }
                } catch (error) {
                    toast.error("Error deleting category.");
                }
            }
        });
    };

    const handleChangeStatus = (id, currentStatus) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "Change the status?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, change it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const res = await axios.patch(CONST.CHANGE_REQUEST_CATEGORY_STATUS, {
                        id: id,
                        is_active: currentStatus == 1 ? 0 : 1
                    }, { headers: { 'Authorization': `Bearer ${isToken}` } });
                    if (res.data.status === 'success') {
                        toast.success(res.data.message);
                        fetchData();
                    }
                } catch (error) {
                    toast.error("Error changing status.");
                }
            }
        });
    };

    const handleSearch = () => {
        setSearchParam({ name: searchName, status: searchStatus });
        setActivePage(1);
    };

    const clearSearch = () => {
        setSearchName('');
        setSearchStatus('');
        setSearchParam({});
        setActivePage(1);
    };

    const handleSort = (column, sortDirection) => {
        setActivePage(1);
        setDataSort({ order: sortDirection, order_by: column.sortField });
    };

    const handlePageChange = (page) => setActivePage(parseInt(page));

    const columns = [
        {
            name: "#",
            cell: (row, index) => <span>{(activePage - 1) * perPage + index + 1}</span>,
            width: "60px",
        },
        {
            name: "Name",
            selector: (row) => row.name,
            sortable: true,
            sortField: "name",
        },
        {
            name: "Code",
            selector: (row) => row.code,
            width: "150px",
        },
        {
            name: "Approval",
            cell: (row) => (
                <span style={{
                    background: row.requires_approval ? '#ecfdf5' : '#f1f5f9',
                    color: row.requires_approval ? '#059669' : '#94a3b8',
                    padding: '2px 8px', borderRadius: 12, fontSize: '0.72rem', fontWeight: 600
                }}>
                    {row.requires_approval ? 'Yes' : 'No'}
                </span>
            ),
            width: "100px",
        },
        {
            name: "Asset",
            cell: (row) => (
                <span style={{
                    background: row.requires_asset ? '#f0f5ff' : '#f1f5f9',
                    color: row.requires_asset ? '#1167e8' : '#94a3b8',
                    padding: '2px 8px', borderRadius: 12, fontSize: '0.72rem', fontWeight: 600
                }}>
                    {row.requires_asset ? 'Yes' : 'No'}
                </span>
            ),
            width: "100px",
        },
        {
            name: "Assignee",
            cell: (row) => row.defaultAssignee ? `${row.defaultAssignee.first_name} ${row.defaultAssignee.last_name}` : '-',
            width: "150px",
        },
        {
            name: "Status",
            cell: (row) => (
                <ReactSwitch
                    onColor={SwitchProps.onColor}
                    onHandleColor={SwitchProps.onHandleColor}
                    handleDiameter={SwitchProps.handleDiameter}
                    uncheckedIcon={SwitchProps.uncheckedIcon}
                    checkedIcon={SwitchProps.checkedIcon}
                    boxShadow={SwitchProps.boxShadow}
                    activeBoxShadow={SwitchProps.activeBoxShadow}
                    height={SwitchProps.height}
                    width={SwitchProps.width}
                    className={SwitchProps.className}
                    checked={row.is_active == 1}
                    onChange={() => handleChangeStatus(row.id, row.is_active)}
                />
            ),
            width: "80px",
        },
        {
            name: "Action",
            cell: (row) => (
                <div style={{ display: 'flex', gap: '8px' }}>
                    <button className="btn btn-link btn-sm p-0" onClick={() => handleShow('Edit', row.id)} title="Edit">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
                    </button>
                    <button className="btn btn-link btn-sm p-0 text-danger" onClick={() => deleteHandler(row.id)} title="Delete">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
                    </button>
                </div>
            ),
            width: "100px",
        },
    ];

    const CustomLoader = () => (<div style={{ padding: "24px" }}><DivLoader color="primary" /></div>);

    /* BootyPagination - same as employee page */
    const BootyPagination = ({ rowCount, onChangePage, currentPage }) => {
        const pages = Math.ceil(rowCount / perPage);
        const pageItems = [];
        for (let i = 1; i <= pages; i++) pageItems.push(i);
        const nextDisabled = currentPage === pages || pages === 0;
        const prevDisabled = currentPage === 1;
        const paginationText = rowCount > 0 ? `Page: ${currentPage}, Showing ${(currentPage - 1) * perPage + 1} to ${Math.min(perPage * currentPage, rowCount)} of ${rowCount} entries` : 'No entries';

        return (
            <div className='row card-footer'>
                <div className='col-md-4 align-self-center'>{paginationText}</div>
                <div className='col-md-8 text-align-right'>
                    <ul className="pagination text-align-right float-right">
                        <li className="page-item"><button className="page-link" onClick={() => onChangePage(currentPage - 1)} disabled={prevDisabled}>«</button></li>
                        {pageItems.map((page, i) => {
                            if (page <= maxPageLimit && page > minPageLimit) {
                                return <li key={i} className={`page-item ${currentPage === page ? "active" : ""}`}>
                                    <button className={`page-link ${currentPage === page ? "active" : ""}`} onClick={() => onChangePage(page)}>{page}</button>
                                </li>;
                            }
                            return null;
                        })}
                        <li className="page-item"><button className="page-link" onClick={() => onChangePage(currentPage + 1)} disabled={nextDisabled}>»</button></li>
                    </ul>
                </div>
            </div>
        );
    };

    return (
        <>
            <Loading loading={fullLoading} background="rgba(0, 0, 0, 0.5)" loaderColor="#fff" />
            <div className="page-header d-print-none">
                <div className="container-xl">
                    <div className="row g-2 align-items-center">
                        <div className="col">
                            <div className="page-pretitle">Manage</div>
                            <h2 className="page-title">Request Categories</h2>
                        </div>
                        <div className="col-12 col-md-auto ms-auto d-print-none">
                            <button className="btn btn-primary" onClick={() => handleShow('Add', null)}>
                                <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-plus" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                    <line x1="12" y1="5" x2="12" y2="19"></line>
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                </svg>
                                &nbsp;Add Category
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="page-body">
                <div className="container-xl">
                    <div className="row row-cards">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <h3 className="card-title">Listing</h3>
                                </div>
                                <div className="card-body border-bottom py-3">
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group mb-3">
                                                <label className="form-label">Name</label>
                                                <input type="text" className="form-control" placeholder="Search name" value={searchName} onChange={(e) => setSearchName(e.target.value)} />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group mb-3">
                                                <label className="form-label">Status</label>
                                                <select className="form-select form-control" value={searchStatus} onChange={(e) => setSearchStatus(e.target.value)}>
                                                    <option value="">All</option>
                                                    <option value="1">Active</option>
                                                    <option value="0">Inactive</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group mb-3">
                                                <label className="form-label">&nbsp;</label>
                                                <div>
                                                    <button type="button" className="btn btn-blue d-none d-sm-inline-block mr-2" onClick={handleSearch}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-search" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path><circle cx="10" cy="10" r="7"></circle><line x1="21" y1="21" x2="15" y2="15"></line>
                                                        </svg>Search
                                                    </button>&nbsp;
                                                    <button type="button" className="btn btn-outline-primary" onClick={clearSearch}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-x" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line>
                                                        </svg>Clear
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="table-responsive">
                                    <DataTable
                                        columns={columns}
                                        data={data}
                                        progressPending={loading}
                                        progressComponent={<CustomLoader />}
                                        pagination="true"
                                        paginationServer
                                        paginationTotalRows={totalRows}
                                        onChangePage={handlePageChange}
                                        paginationPerPage={perPage}
                                        paginationComponent={BootyPagination}
                                        sortServer
                                        onSort={handleSort}
                                    />
                                </div>
                                <div className="card-footer d-flex align-items-center">
                                    <p className="m-0 text-muted">Showing <span>{totalRecords}</span> entries</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add/Edit Modal */}
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{action} Request Category</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group mb-3">
                                    <label className="form-label required">Name</label>
                                    <input type="text" className="form-control" placeholder="e.g. Hardware Request" value={name} onChange={(e) => handleNameChange(e.target.value)} />
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="form-group mb-3">
                                    <label className="form-label required">Code</label>
                                    <input type="text" className="form-control" placeholder="e.g. hardware_request" value={code} onChange={(e) => setCode(e.target.value)} />
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="form-group mb-3">
                                    <label className="form-label">Description</label>
                                    <input type="text" className="form-control" placeholder="Brief description" value={description} onChange={(e) => setDescription(e.target.value)} />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group mb-3">
                                    <label className="form-label">Requires Approval</label>
                                    <div>
                                        <ReactSwitch
                                            onColor={SwitchProps.onColor}
                                            onHandleColor={SwitchProps.onHandleColor}
                                            handleDiameter={SwitchProps.handleDiameter}
                                            uncheckedIcon={SwitchProps.uncheckedIcon}
                                            checkedIcon={SwitchProps.checkedIcon}
                                            boxShadow={SwitchProps.boxShadow}
                                            activeBoxShadow={SwitchProps.activeBoxShadow}
                                            height={SwitchProps.height}
                                            width={SwitchProps.width}
                                            className={SwitchProps.className}
                                            checked={requiresApproval}
                                            onChange={(val) => setRequiresApproval(val)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group mb-3">
                                    <label className="form-label">Requires Asset</label>
                                    <div>
                                        <ReactSwitch
                                            onColor={SwitchProps.onColor}
                                            onHandleColor={SwitchProps.onHandleColor}
                                            handleDiameter={SwitchProps.handleDiameter}
                                            uncheckedIcon={SwitchProps.uncheckedIcon}
                                            checkedIcon={SwitchProps.checkedIcon}
                                            boxShadow={SwitchProps.boxShadow}
                                            activeBoxShadow={SwitchProps.activeBoxShadow}
                                            height={SwitchProps.height}
                                            width={SwitchProps.width}
                                            className={SwitchProps.className}
                                            checked={requiresAsset}
                                            onChange={(val) => setRequiresAsset(val)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group mb-3">
                                    <label className="form-label">Sort Order</label>
                                    <input type="number" className="form-control" value={sortOrder} onChange={(e) => setSortOrder(e.target.value)} />
                                </div>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>Close</Button>
                    <Button variant="primary" onClick={handleSubmit} disabled={disabled}>{disabled ? 'Submitting...' : 'Submit'}</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default RequestCategories;
